@use '@lib/assets/styles/main.scss' as *;

.tabsWrap {
  border-bottom: 1px solid $gray100;
  margin-bottom: 16px;
  position: relative;
  @include responsive($md1) {
    margin-left: -32px;
    margin-right: -32px;
  }
  @include responsive(null, $md1) {
    margin-left: -16px;
    margin-right: -16px;
  }

  &.tabsWrapCentered {
    display: flex;
    justify-content: center;
  }

  &::after {
    content: '';
    background-color: $gray100;
    height: 1px;
    position: absolute;
    bottom: -1px;
    width: 100vw;
    left: 50%;
    transform: translateX(-50%);
  }

  .tabsScroll {
    max-width: 100%;
    max-width: 100vw;
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;
    -webkit-overflow-scrolling: touch;
    &::-webkit-scrollbar {
      display: none;
    }

  }
}
